const Metrics = {
  section: 25,
  baseMargin: 10,
  doubleBaseMargin: 20,
  doubleSection: 50,
};

export default Metrics;
